export const ROLES = {
  super_admin: "Super Admin",
  admin_iprjt: "Admin IPRJT",
  case_manager: "Case Manager",
  petugas_admisi: "Petugas Admisi",
  rawat_inap: "Rawat Inap",
};

export const ROLE_BADGE = {
  super_admin: "bg-[#267B84]/10 text-[#267B84] border-[#267B84]/30",
  admin_iprjt: "bg-[#00B9AD]/10 text-[#009E94] border-[#00B9AD]/30",
  case_manager: "bg-[#60C0D0]/15 text-[#2a8ba0] border-[#60C0D0]/40",
  petugas_admisi: "bg-[#CDDC29]/20 text-[#6b7413] border-[#CDDC29]/50",
  rawat_inap: "bg-slate-100 text-slate-600 border-slate-300",
};

export const STATUS_KAMAR = ["Sudah Dapat Kamar", "Menunggu Kamar", "Batal Operasi"];

// What the user sees for each stored status_kamar value, everywhere in the app. Display-only: the values above are
// what is stored, sent and filtered on (Antrian, Dashboard, exports all key on them), so never compare against a label.
// Keep in sync with STATUS_KAMAR_LABEL in backend/server.py (PDF/Excel exports, error and audit texts).
export const STATUS_KAMAR_LABEL = {
  "Sudah Dapat Kamar": "Sudah Dapat Kamar",
  "Menunggu Kamar": "Waiting List",
  "Batal Operasi": "Batal Masuk Ranap",
};
export const statusLabel = (s) => STATUS_KAMAR_LABEL[s] || s;

export const STATUS_STYLE = {
  "Sudah Dapat Kamar": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Menunggu Kamar": "bg-amber-50 text-amber-700 border-amber-200",
  "Batal Operasi": "bg-red-50 text-red-700 border-red-200",
};

export const STATUS_CHART_COLOR = {
  "Sudah Dapat Kamar": "#00B9AD",
  "Menunggu Kamar": "#CDDC29",
  "Batal Operasi": "#EF4444",
};

// "JKN" stays here for staff (editing/filtering old records) but is dropped on the public /ajukan form —
// see JAMINAN_PUBLIK in AjukanPage.jsx, which derives from this list. "Lainnya" was renamed to "BPJS TK"
// everywhere (staff Tambah/Edit + filters included) -- old "Lainnya" records still show/save fine, they're
// just no longer a pickable option going forward.
export const JAMINAN = ["JKN", "BPJS", "Tunai", "Asuransi", "BPJS TK"];
export const KELAS_JAMINAN = ["1", "2", "3"];
export const ADA_TIDAK = ["Ada", "Tidak Ada"];
export const E_KMKB = ["Sudah", "Belum"];
export const JENIS_KELAMIN = ["Laki-laki", "Perempuan"];

// Solid color blocks (not just colored text) per JK, so the badge reads at a glance.
export const JENIS_KELAMIN_STYLE = {
  "Laki-laki": "bg-blue-500 text-white",
  "Perempuan": "bg-pink-500 text-white",
};

// Soft full-row tint per JK (row background, not the badge) -- one shade up from -50 for visible contrast
// against white at a glance, but still well short of the solid badge color so row text stays readable.
export const JENIS_KELAMIN_ROW_BG = {
  "Laki-laki": "bg-blue-100 hover:bg-blue-200",
  "Perempuan": "bg-pink-100 hover:bg-pink-200",
};

export const RSCM = {
  primary: "#00B9AD",
  primaryDark: "#009E94",
  secondary: "#267B84",
  accent: "#60C0D0",
  highlight: "#CDDC29",
};
